import { finance } from "@/services/finance";
import { Button, TextInput } from "@mantine/core";
import { useState } from "react";
import classes from "@/modules/finance/finance.module.css";
import { DateField, MoneyInput, isoToday, useFinanceWrite } from "@/modules/finance/shared";

// First visit: a cash box and a bank account, each with its opening balance (not income), and
// optionally the card reader that pays into the bank.
export default function Setup() {
  const [cash, setCash] = useState({ name: "صندوق اصلی", amount: "" });
  const [bank, setBank] = useState({ name: "حساب بانکی مجموعه", amount: "" });
  const [pos, setPos] = useState({ name: "", code: "" });
  const [date, setDate] = useState(isoToday());
  const [busy, setBusy] = useState(false);

  const account = useFinanceWrite((body: { name: string; kind: "cash" | "bank" }, key) => finance.createAccount(body, key));
  const opening = useFinanceWrite((body: { accountId: number; amountRial: string; businessDate: string; reference: string }, key) => finance.opening(body, key));
  const terminal = useFinanceWrite((body: { name: string; code: string; destinationAccountId: number }, key) => finance.createTerminal(body, key));

  const start = async () => {
    setBusy(true);
    try {
      const cashId = await account.run({ name: cash.name.trim(), kind: "cash" });
      if (!cashId) return;
      const bankId = await account.run({ name: bank.name.trim(), kind: "bank" });
      if (!bankId) return;
      if (Number(cash.amount) > 0) await opening.run({ accountId: cashId.id, amountRial: cash.amount, businessDate: date, reference: "مانده افتتاحیه صندوق" });
      if (Number(bank.amount) > 0) await opening.run({ accountId: bankId.id, amountRial: bank.amount, businessDate: date, reference: "مانده افتتاحیه بانک" });
      if (pos.name.trim() && pos.code.trim()) await terminal.run({ name: pos.name.trim(), code: pos.code.trim(), destinationAccountId: bankId.id });
    } finally {
      setBusy(false);
    }
  };

  const valid = cash.name.trim() && bank.name.trim();
  return (
    <section className={classes.panel}>
      <div className={classes.panelHead}>
        <div>
          <h2>راه‌اندازی امور مالی</h2>
          <small>یک صندوق و یک حساب بانکی برای شروع کافی است. مانده افتتاحیه درآمد حساب نمی‌شود.</small>
        </div>
      </div>
      <div className={classes.fields}>
        <TextInput label="نام صندوق نقدی" value={cash.name} onChange={(e) => setCash({ ...cash, name: e.currentTarget.value })} withAsterisk />
        <MoneyInput label="موجودی فعلی صندوق" value={cash.amount} onChange={(amount) => setCash({ ...cash, amount })} />
        <TextInput label="نام حساب بانکی" value={bank.name} onChange={(e) => setBank({ ...bank, name: e.currentTarget.value })} withAsterisk />
        <MoneyInput label="مانده فعلی حساب بانکی" value={bank.amount} onChange={(amount) => setBank({ ...bank, amount })} />
        <TextInput label="نام دستگاه پوز (اختیاری)" placeholder="مثلاً پوز پیشخوان" value={pos.name} onChange={(e) => setPos({ ...pos, name: e.currentTarget.value })} />
        <TextInput label="شناسه پوز" placeholder="POS-1" value={pos.code} onChange={(e) => setPos({ ...pos, code: e.currentTarget.value })} styles={{ input: { direction: "ltr", textAlign: "left" } }} />
        <DateField label="تاریخ مانده‌ها" value={date} max={isoToday()} onChange={setDate} />
      </div>
      <p className={classes.note}>ثبت‌های قبل از این تاریخ پذیرفته نمی‌شوند. پوز به حساب بانکی وصل می‌شود و پول آن تا تسویه، «در انتظار واریز» می‌ماند.</p>
      <div><Button color="violet" loading={busy} disabled={!valid} onClick={start}>شروع امور مالی</Button></div>
    </section>
  );
}
